import { render, staticRenderFns } from "./CarsByPrice.vue?vue&type=template&id=2dcefc5c&scoped=true&"
import script from "./CarsByPrice.vue?vue&type=script&lang=ts&"
export * from "./CarsByPrice.vue?vue&type=script&lang=ts&"
import style0 from "./CarsByPrice.vue?vue&type=style&index=0&id=2dcefc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcefc5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSpacer})
